import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { inject } from '@vercel/analytics'
import './index.css'
import App from './App.jsx'

// Initialize Vercel analytics only when explicitly enabled
// Prevents loading '/_vercel/insights/script.js' in non-Vercel environments
if (import.meta.env.VITE_ENABLE_VERCEL_ANALYTICS === 'true') {
  inject();
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
